import { render } from "./Trickster.vue?vue&type=template&id=6824e543&scoped=true&ts=true"
import script from "./Trickster.vue?vue&type=script&lang=ts"
export * from "./Trickster.vue?vue&type=script&lang=ts"

import "./Trickster.vue?vue&type=style&index=0&id=6824e543&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6824e543"]])

export default __exports__